module.exports = __webpack_public_path__ + "img/public_resources_narrow_white.b37b9c4b.svg";